import { trackPageView, trackEvent } from './piwikTracker';

export default {
  trackPageView,
  trackEvent,
};
